import React from 'react';
import './App.css';
import {
    Route,
    BrowserRouter,
    Routes,
    Outlet
} from "react-router-dom";
import MainAppBar from './MainAppBar';
import { ThemeProvider, createTheme, useTheme } from '@mui/material/styles';
import Link from '@mui/material/Link';

import Home, { ShowWait } from './components/home/Home';

import Login from './components/login/Login';
import PaginaHtml from './components/page/PaginaHtml';

import BpmnEditorPanel from './components/bpm/BpmnEditorPanel';
import DinamicForm from './components/bpm/DinamicForm';
import BpmnManagerPanel from './components/bpm/manager/BpmnManagePanel';
import SolicitacoesManagerPanel from './components/bpm/manager/SolicitacoesManagerPanel';
import FlowPanel from './components/bpm/manager/FlowPanel';
import ModeloTable from './components/bpm/manager/ModeloTable';
import ModeloForm from './components/bpm/manager/ModeloForm';
// import Organograma from './components/bpm/manager/Organograma';
import CadastrarUsuario from './components/login/CadastrarUsuario2';
import PanelCDNRoot from './CDN/PanelCDNRoot';

import AcessoPage from './components/page/user/AcessoPage';
import AcessoUserPage from './components/page/user/AcessoUserPage';
import TablePortal from './components/page/portal/TablePortal';
import VeryEditorJS from './components/page/portal/editorJs/VeryEditorJS'
import Service from './util/Service';
import ProjetoTable from './components/projeto/ProjetoTable';
import ProjectForm from './components/projeto/ProjectForm';
import KanBanRoot from './components/projeto/kanban/KanBanRootV2';
// import DGTeste from './util/DGTeste';
// import WebSocketChat from './util/WebSocketChat';
// import DNDListTeste from './util/DNDListTeste';

import ProjetoPage from './components/projeto/ProjetoPage';

import MinhaPagina from './components/page/portal/MinhaPagina';
import BackGroundManagerPanel from './components/bpm/manager/BackGroundManagerPanel';
import FlowBakgroundPanel from './components/bpm/manager/FlowBackgroundPanel';
import UsuariosTable from './components/page/portal/user/UsuariosTable';
import UsuarioForm from './components/page/portal/user/UsuarioForm';
import ProjetoPageView from './components/projeto/ProjetoPageView';
import KanbanRootView from './components/projeto/kanban/KanbanRootView';
import PaginaHtmlDinamica from './components/page/PaginaHtmlDinamica';
// import RecursosPanel from './components/page/portal/RecursosPanel';
import ProfilePanel from './components/page/portal/user/ProfilePanel';
import MyAccountPanel from './components/page/portal/user/MyAccountPanel';
import ErroPage from './components/home/ErroPage';
import CalendarioPanel from './components/projeto/evento/CalendarioPanel';
// import SettingPanel from './components/page/portal/setting/SettingPanel';
import EditarPaginaPanel from './components/page/editar/EditarPaginaPanel';
import BpmnProcessDataPanel from './components/bpm/BpmnProcessDataPanel';

import FlowProcessPanel from './components/bpm/manager/FlowProcessPanel';
import DecisionTreeFull from './components/arvoreProcess/DecisionTreeFull';
import Notificacao from './components/page/portal/comps/notificacao/Notificacao';
// import ChatPanel from './components/chat/ChatPanel';
//import ChatMainPanel from './components/chatBoot/ChatMainPanel';
// import GerenciarPanel from './components/bpm/manager/GerenciarPanel';
// import ProjetoRoot from './components/projeto/ProjetoRoot';
// import LoginPA from './components/login/LoginPA';
const ChatPanel = React.lazy(() => import('./components/chat/ChatPanel'));
const ChatMainPanel = React.lazy(() => import('./components/chatBoot/ChatMainPanel'));
const GerenciarPanel = React.lazy(() => import('./components/bpm/manager/GerenciarPanel'));
const ProjetoRoot = React.lazy(() => import('./components/projeto/ProjetoRoot'));
const LoginPA = React.lazy(() => import('./components/login/LoginPA'));
const RecursosPanel = React.lazy(() => import('./components/page/portal/RecursosPanel'));
const SettingPanel = React.lazy(() => import('./components/page/portal/setting/SettingPanel'));
const Organograma = React.lazy(() => import('./components/bpm/manager/Organograma'));

function AppRouter() {
    const themeDf = useTheme();
    const [darkMode, setDarkMode] = React.useState(false);
    const [edit, setEdit] = React.useState(false);
    const [pageRoot, setPageRoot] = React.useState();
    const [wait, setWait] = React.useState(true);
    const [mode, setMode] = React.useState('light'); // 'light' or 'dark'
    const [palette, setPalette] = React.useState();
    
    const theme = React.useMemo(() => {
        const root = document.documentElement;
        if (!palette) {
            if (root) {
                root.style.setProperty('--pd-primary-main', darkMode? themeDf.palette.common.black: themeDf.palette.primary.main);
                root.style.setProperty('--pd-primary-dark', darkMode? themeDf.palette.common.black: themeDf.palette.primary.dark);
                root.style.setProperty('--pd-primary-light', darkMode? themeDf.palette.common.black: themeDf.palette.primary.light);
                root.style.setProperty('--pd-success', themeDf.palette.success.main);
                root.style.setProperty('--pd-info'   , themeDf.palette.info.main);
                root.style.setProperty('--pd-error'  , themeDf.palette.error.main);
                root.style.setProperty('--pd-warning', themeDf.palette.warning.main);
                root.style.setProperty('--pd-background', themeDf.palette.background.paper);
            }
            return createTheme({
                palette: {
                    mode,
                    // primary: palette.primary
                },
            })
        }else{       
            if (root) {            
                root.style.setProperty('--pd-primary-main', darkMode? themeDf.palette.common.black: palette.primary.main);
                root.style.setProperty('--pd-primary-dark', darkMode? themeDf.palette.common.light: palette.primary.dark);
                root.style.setProperty('--pd-primary-light', darkMode? themeDf.palette.common.black: palette.primary.light);
                root.style.setProperty('--pd-success', themeDf.palette.success.main);
                root.style.setProperty('--pd-info'   , themeDf.palette.info.main);
                root.style.setProperty('--pd-error'  , themeDf.palette.error.main);
                root.style.setProperty('--pd-warning', themeDf.palette.warning.main);
                root.style.setProperty('--pd-background', themeDf.palette.background.paper);
            }
            if( darkMode){
                return createTheme({
                    palette: {
                        mode,                  
                    },
                })  
            }
            return createTheme({
                palette: {
                    mode: mode,
                    primary: palette.primary,
                    secondary: palette.secondary,
                    common: palette.common,
                    success: palette.success,
                    background: palette.background,
                    warning: palette.warning,
                    text: palette.text,
                    error: palette.error,
                    info: palette.info,
                },
            })
        }
    }, [mode, palette]);

    React.useEffect(() => {
        const page = localStorage.getItem("pageRoot");
        if (!page) {
            buscaPaginaRoot();
        } else {
            setPageRoot(JSON.parse(page));
            setTimeout(() => setWait(false), 300);
        }
        buscaTheme();
        buscaCss();
        buscaJS();
        
    }, []);

    const buscaCss=() => {
        Service.GET('/api/setting/css').then(r => {            
            if( r.success){
                if( r.css && r.css.confs){
                    const css = document.createElement('style');  
                    // link.rel = 'stylesheet';
                    // link.type = 'text/css';
                    css.textContent = r.css.confs;                    
                    document.head.appendChild(css);
                }
            }
        });
    }
    const buscaJS=()=>{
        Service.GET('/api/setting/js').then(r => {            
            if( r.success){
                if( r.js && r.js.confs){
                    const tag = document.createElement('script');                    
                    tag.textContent = r.js.confs;
                    document.head.appendChild(tag);
                }
            }
        });
    }
    const buscaTheme = () => {
        Service.GET('/api/setting/theme').then(r => {            
            if (r) {
                setPalette(r.confs);
            }
        });
    }
    function buscaPaginaRoot() {
        Service.GET('/api/paginaHtml/buscaPorNome/Root').then(r => {
            setWait(false);
            if (r && r.length > 0) {
                localStorage.setItem("pageRoot", JSON.stringify(r[0]));
                setPageRoot(r[0]);
            }
        });
    }

    const handleDarkMode = () => {
        setDarkMode(!darkMode);
        setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
    }

    if (wait) {
        return (
            <ShowWait />
        )
    }

    return (
        <BrowserRouter >
            <ThemeProvider
                // theme={darkMode ? darkTheme : defaultTheme}
                theme={theme}
            >

                <Routes>
                    <Route path="/" element={<MainAppBar darkMode={darkMode} handleDarkMode={handleDarkMode} edit={edit} setEdit={setEdit} pageRoot={pageRoot} />}>
                        <Route index element={<Home edit={edit} layout={pageRoot ? pageRoot.layout : null} />} />
                        <Route path="*" element={<NoMatch />} />
                        <Route path="/home" element={<Home layout={pageRoot ? pageRoot.layout : null}/>} />
                        <Route path="/erro" element={<ErroPage />} />

                        <Route path="/pagina/*" element={<PaginaHtml edit={edit} />} />
                        <Route path="/paginaDinamica/*" element={<PaginaHtmlDinamica edit={edit} />} />
                        <Route path="/minhaPagina" element={<MinhaPagina />} />
                        <Route path="/recursos/:id" element={<RecursosPanel />} />
                        <Route path="/recursos" element={<RecursosPanel />} />
                        <Route path="/users" element={<UsuariosTable />} />
                        <Route path="/users/profile" element={<ProfilePanel />} />
                        <Route path="/users/myAccount" element={<MyAccountPanel />} />

                        <Route path="/form/:id" element={<DinamicForm />} />
                        <Route path="/tablePortal" element={<TablePortal />} />
                        <Route path="/projeto/:id" element={<ProjetoPageView />} />
                        <Route path="/kanban/:id/:idKanban" element={<KanbanRootView />} />
                        <Route path="/calendario" element={<CalendarioPanel />} />
                        <Route path="/setting/*" element={<SettingPanel />} />

                        <Route path="/editarPagina/:id" element={<EditarPaginaPanel />} />
                        <Route path="/chatBoot/*" element={<ChatMainPanel />} />
                        <Route path="/chat/*" element={<ChatPanel />} />
                        <Route path="/notifManager/*" element={<Notificacao />} />
                        
                    </Route>

                    {/* <Route path="/aprovacao" element={<AprovacaoPanel />} >
                        <Route path="*" element={<NoMatch />} />
                        <Route path="fluxo/:estrutura/:resposta/:id" element={<AprovacaoFluxo />} />
                        <Route path="anexo/:id" element={<AprovacaoAnexos />} />
                    </Route> */}

                    <Route path="/gerenciar" element={<GerenciarPanel />} >
                        <Route path="*" element={<NoMatch />} />
                        <Route path="bpm" element={<BpmnManagerPanel />} />
                        <Route path="bpm/see/:id" element={<BpmnProcessDataPanel />} />
                        <Route path="solicitacoes" element={<SolicitacoesManagerPanel />} />
                        <Route path="execucoesBG" element={<BackGroundManagerPanel />} />
                        <Route path="flow/:id" element={<FlowPanel />} />
                        <Route path="flowProcess/:id" element={<FlowProcessPanel />} />
                        <Route path="flowBackground/:id" element={<FlowBakgroundPanel />} />
                        <Route path="modelos" element={<ModeloTable />} />
                        <Route path="novoModelo" element={<ModeloForm />} />
                        <Route path="editModelo/:id" element={<ModeloForm />} />
                        <Route path="acesso" element={<AcessoPage />} />
                        <Route path="acessoUser" element={<AcessoUserPage />} />
                        <Route path="organograma" element={<Organograma />} />
                        <Route path="cadastroUser" element={<CadastrarUsuario />} />
                        <Route path="tablePortal" element={<TablePortal />} />
                        <Route path="testeEditor" element={<VeryEditorJS />} />
                        <Route path="users" element={<UsuariosTable />} />
                        <Route path="users/form/:id" element={<UsuarioForm />} />
                        <Route path="decisionTree" element={<DecisionTreeFull />} />
                        <Route path="decisionTree/:id" element={<DecisionTreeFull />} />
                    </Route>
                    
                    <Route path="/CDN" element={<PanelCDNRoot darkMode={darkMode} handleDarkMode={handleDarkMode} edit={edit} setEdit={setEdit} />}>
                        <Route index element={<Home edit={edit} />} />
                        <Route path="*" element={<NoMatch />} />                        
                    </Route>

                    <Route path="/project" element={<ProjetoRoot darkMode={darkMode} handleDarkMode={handleDarkMode} />}>
                        <Route index element={<ProjetoTable />} />
                        <Route path="*" element={<NoMatch />} />
                        <Route path="newProject" element={<ProjectForm />} />
                        <Route path="pagina/:id" element={<ProjetoPage />} />
                        <Route path="kanban/:id" element={<KanBanRoot />} />
                        <Route path="kanban/:id/:idKanban" element={<KanBanRoot />} />
                        <Route path="kanban/:id/:idKanban/:idCartao" element={<KanBanRoot />} />
                    </Route>
{/* 
                    <Route path="/reembolso" element={<HomeRoot />} >
                        <Route path="*" element={<NoMatch />} />
                        <Route path="rh/resposta/:resp" element={<ProblemaClienteEspecifico />} />
                    </Route> */}

                    <Route path="/userTask/:id" element={<DinamicForm />} />

                    <Route path="/novaIntegracao" element={<BpmnEditorPanel />} />
                    <Route path="/editBPM/:id" element={<BpmnEditorPanel stylePacote={{
                        zIndex: 2,
                        // width:'300px',
                        position: 'absolute',
                        // position: 'relative',
                        top: '0',
                        left: '50%',
                        transform: 'translateX(-50%)'
                        // display:'flex', justifyContent: 'center', alignItems:"flex-start"
                    }} />} />

                    {/* <Route path="/teste" element={
                        <div>

                            <p><a href='/teste/ws'>WS - Teste</a> </p>
                            <p><a href='/teste/dnd'>DG - Teste</a> </p>
                            <p><a href='/teste/dndList'>DG - List</a> </p>
                            <div><Outlet /></div>
                        </div>
                    }>
                        <Route index element={<p>TESTE</p>}
                        />
                        <Route path="*" element={<NoMatch />} />
                        <Route path="dnd" element={<DGTeste />} />
                        <Route path="ws" element={<WebSocketChat />} />
                        <Route path="dndList" element={<DNDListTeste />} />
                    </Route> */}

                    <Route path="/login" element={<Login />} />
                    <Route path="loginPrimeiroAcesso" element={<LoginPA/>} />

                    {/* <Route path="/loginMS" element={<LoginMS />} /> */}

                </Routes>
            </ThemeProvider>
        </BrowserRouter>
    );
}

export default AppRouter;

function NoMatch() {
    return (
        <div>
            <h2>Pagina não encontrada</h2>
            <p>
                <Link href="/">volte para a página inicial</Link>
            </p>
        </div>
    );
}
